var VolumeBreaks = class extends HTMLElement {
    constructor() {
        super();
        
        this.setCurrentQuantity();
        this.selectCurrentVolume.bind(this);
  
    }

    connectedCallback() {
        window.addEventListener('volume:pricing:current', this.selectCurrentVolume.bind(this));

    }

    selectCurrentVolume(event){
        
       var quantity = event.currentQty.qty;
       var items = this.querySelectorAll('.volume-breaks__item');
       items.forEach(item => {
        var volume_input = item.querySelector('input');

        if( quantity >= volume_input.min && quantity <= volume_input.max ){
            volume_input.checked = true;
            var event = new Event("volume:pricing:total", { bubbles: true });
            event.setTotal = {
                    qty: quantity,
                    price: volume_input.value,
                    percentage: volume_input.dataset.discount
                            };
            window.dispatchEvent(event);
        }
       });
    }
    setCurrentQuantity(){
        var items = this.querySelectorAll('.volume-breaks__item');
       items.forEach(item => {
        item.addEventListener('click',(e) => {
            e.preventDefault();
            var volume_input = item.querySelector('input');
            volume_input.checked = true;
            var event = new Event("volume:pricing:set", { bubbles: true });
            event.setQty = volume_input.min;
            window.dispatchEvent(event);
        });
       });
    }

  };
  if (!window.customElements.get("volume-breaks")) {
    window.customElements.define("volume-breaks", VolumeBreaks);
  }
  



